import React, {useEffect, useMemo, useState} from 'react';
import { TrainingCompletionProps } from "./TrainingCompletion.props";
import { Box, Stack, Typography } from "@mui/material";
import './TrainingCompletion.css';
import { DataTables } from "../DataTables";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import {formatNumber, getCurrentCellStore, getUserName} from "../../utils/util";
import { UserAvatarLetters } from "../UserAvatarLetters";
import { images } from "../../constants/images";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  getTrainingCompletionListEvents,
  getTrainingCompletionListEventsDataSelector, IDataTrainingCompletion,
  IDataTrainingCompletionList, IGroupTrainingCompletionList, removeTrainingCompletion
} from "../../redux/getTrainingCompletionSilce";
import { LoadingPage } from "../LoadingPage";
import {CustomChip} from "../CustomChip";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

interface trainingCompletionRow extends IDataTrainingCompletionList {
  id: number;
}
interface groupTrainingCompletionRow extends IGroupTrainingCompletionList {
  id: number;
}

const TrainingCompletion: React.FC<TrainingCompletionProps> = ({ cellId,isAttribute = false }) => {
  const [trainingCompletionRows, setTrainingCompletionRows] = useState<trainingCompletionRow[] | groupTrainingCompletionRow[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const { dataTrainingCompletion, isLoading } = useAppSelector(getTrainingCompletionListEventsDataSelector);
  const [selectedRow, setSelectedRow] = useState<any[]>([]);

  const userCurrentCellStore = getCurrentCellStore();
  const dispatch = useAppDispatch();

  const DEFAULT_PARAMS = {
    cell_id:cellId,
    offset_rankings: 1,
    offset_groups: 1,
    limit_rankings: 10,
    limit_groups: 10
  };
  const columns: GridColDef[] = useMemo(() => {
    const baseColumns: GridColDef[] = [
      {
        field: 'rank',
        headerName: '',
        sortable: false,
        width:20,
        align: "center",
        headerClassName: 'data-table-header-cell',
        renderCell: (params: GridRenderCellParams) => {
          return <p>#{params.row.rank}</p>;
        }
      },
      {
        field: 'learner_email',
        headerName: 'Learners',
        flex: 5,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => {
          return <Box
            sx={{
              display: "flex",
              alignItems: "center",
              minHeight: '68px'
            }}
          >
            {getUserName(params.row) ? (
              <UserAvatarLetters classNames={'avatar-list-training-completion'} name={getUserName(params.row)} />
            ) : (
              <div className="profile-avatar">
                <img className="profile-picture" src={images.NoAvatar} alt="avatar" />
              </div>
            )}
            <Stack sx={{ ml: '10px', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
              <Typography className={'name-cell row-selected'}>
                {params.row.first_name} {params.row.last_name}
              </Typography>
              {params.row.learner_id === userCurrentCellStore?.student_id && (
                <CustomChip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        fontFamily: 'Montserrat',
                        fontSize: 14
                      }}>
                      Your Position
                      <AccountCircleIcon sx={{ fontSize: 24, color: '#193051' }} />
                    </Box>
                  }
                  className={`custom-chip position btn-your-position`}
                />
              )}
            </Stack>
          </Box>
        }
      },
      {
        field: 'total_points',
        headerName: 'Total points',
        sortable: false,
        flex: 2,
        align: 'right',
        headerClassName: 'header-sort-right',
        sortingOrder: ['asc', 'desc'],
        renderCell: (params: GridRenderCellParams) => (
          formatNumber(params.value)
        )
      }];
    if (isAttribute) {
      return [
        {
          field: 'rank',
          headerName: '',
          sortable: false,
          width:20,
          align: "center",
          headerClassName: 'data-table-header-cell',
          renderCell: (params: GridRenderCellParams) => {
            return <p>#{params.row.rank}</p>;
          }
        },
        {
          field: 'group',
          headerName: 'Group',
          flex: 4,
          sortable: false,
          renderCell: (params: GridRenderCellParams) => {
            return <Box
              sx={{
                display: "flex",
                alignItems: "center",
                minHeight: '68px'
              }}
            >
              {(params && params.value) ? (
                <UserAvatarLetters classNames={'avatar-list-training-completion'} name={params.value} />
              ) : (
                <div className="profile-avatar">
                  <img className="profile-picture" src={images.NoAvatar} alt="avatar" />
                </div>
              )}
              <Stack sx={{ ml: '10px', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                <Typography className={'name-cell row-selected'}>{params.value}</Typography>
                {params.row.has_group && (
                  <CustomChip
                    label={
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          fontFamily: 'Montserrat',
                          fontSize: 14
                        }}>
                        Your Group
                        <AccountCircleIcon sx={{ fontSize: 24, color: '#193051' }} />
                      </Box>
                    }
                    className={`custom-chip position btn-your-group`}
                  />
                )}
              </Stack>
            </Box>
          }
        },
        {
          field: 'average_points',
          headerName: 'Average Points',
          sortable: false,
          flex: 2,
          align: 'right',
          headerClassName: 'header-sort-right',
          sortingOrder: ['asc', 'desc'],
          renderCell: (params: GridRenderCellParams) => (
            formatNumber(params.value)
          )
        }
      ];
    }

    return baseColumns;
  }, [isAttribute]);

  const removeTrainingCompletionData = async () => {
    await dispatch(
      removeTrainingCompletion()
    );
  };
  const getTrainingCompletion = async (params: any) => {
    await dispatch(
      getTrainingCompletionListEvents(params)
    );
  };

  useEffect(() => {
    getTrainingCompletion(DEFAULT_PARAMS)
    return () => {
      removeTrainingCompletionData()
    }
  }, [dispatch]);

  const handleRowsTable = (dataFilter : IDataTrainingCompletion, attribute:boolean) => {
    let rows =[];
    let selectedRowIds =[];
    if(attribute) {
      rows = dataFilter?.groups?.data.map((learner, index) => ({
        ...learner,
        id: index
      }));
      selectedRowIds = rows
        .filter((row: groupTrainingCompletionRow) => row?.has_group)
        .map((row: groupTrainingCompletionRow) => row.id);
    } else {
      rows = dataFilter?.rankings?.data.map((learner, index) => ({
        ...learner,
        id: index
      }));
      selectedRowIds = rows
        .filter((row: trainingCompletionRow) => row?.learner_id === userCurrentCellStore?.student_id)
        .map((row: trainingCompletionRow) => row.id);
    }

    setSelectedRow(selectedRowIds)
    setTrainingCompletionRows(rows);
    setTotalRows(rows?.length);
  }

  useEffect(() => {
    handleRowsTable(dataTrainingCompletion, isAttribute)
  }, [dataTrainingCompletion, isAttribute]);

  const fetchMoreDataTrainingCompletion = async (dataTraining: IDataTrainingCompletion ) => {
    const { rankings, groups } = dataTraining;
    let params = {};
    if (!isAttribute) {
      const nextOffset = rankings?.pagination?.offset + 1;
      params = { ...DEFAULT_PARAMS, offset_rankings: nextOffset };
      if (rankings?.pagination?.has_more) {
        await getTrainingCompletion(params);
      }
    } else {
      const nextOffset = groups?.pagination?.offset + 1;
      params = { ...DEFAULT_PARAMS, offset_groups: nextOffset };
      if (groups?.pagination?.has_more) {
        await getTrainingCompletion(params);
      }
    }
  };

  return (
    <>
      <Stack
        // spacing={isMobile ? 5 : 0}
        className='training-completion'
        id="training-completion"
      >
        <DataTables
          tblRows={trainingCompletionRows}
          tblColumns={columns}
          totalRows={totalRows}
          sortingMode={'server'}
          autoHeight={false}
          rowSelectionModel={selectedRow}
          noRowsLabel={'No Data Available'}
          onTableScrollEnd={(data:IDataTrainingCompletion)=>fetchMoreDataTrainingCompletion(data)}
          tableScrollData={dataTrainingCompletion}
        />
      </Stack>
      <LoadingPage open={isLoading} />
    </>
  );
};

export default TrainingCompletion;
